/* eslint-disable prefer-destructuring */
import { dwmRepository } from 'common/repositories/index';
import Mixpanel from 'common/services/stats/-RFC.Mixpanel';

const _directiveDependencies = [];
const _controllerDependencies = ['$scope', '$state', '$rootScope'];

class DwmAssetsController {

    constructor($scope, $state, $rootScope) {

        $scope.assetsLoading = true;

        const buildAssets = () => {

            if ($scope.aiaSubscriptionCancelled || $scope.dwmLiteSubscriptionCancelled) {

                $scope.assets = {
                    emails: {
                        maxCount: 5,
                        entries: [],
                        order: 1,
                    },
                    phoneNumbers: {
                        maxCount: 5,
                        entries: [],
                        order: 2,
                    },
                    creditDebitCards: {
                        maxCount: 10,
                        entries: [],
                        order: 3,
                    },
                    bankAccounts: {
                        maxCount: 10,
                        entries: [],
                        order: 4,
                    },
                    addresses: {
                        maxCount: 5,
                        entries: [],
                        order: 5,
                    },
                    driversLicense: {
                        maxCount: 1,
                        entries: [],
                        order: 6,
                    },
                    gamerTags: {
                        maxCount: 10,
                        entries: [],
                        order: 7,
                    },
                    insuranceCards: {
                        maxCount: 5,
                        entries: [],
                        order: 8,
                    },
                    mothersMaidenName: {
                        maxCount: 1,
                        entries: [],
                        order: 9,
                    },
                };

                $scope.assetsLoading = false;

            }

        };

        buildAssets();

        const dwmStatusListener = $rootScope.$on('dwm_status_fetch_completed', () => {

            buildAssets();

        });

        const onDwmDataNext = () => {

            const assets = dwmRepository.getAll('assets') || {};

            if (assets.primaryMember) {

                const assetsObj = assets.primaryMember.monitoredAccounts;

                if (assetsObj.emails) {

                    assetsObj.emails.order = 1;

                }

                if (assetsObj.phoneNumbers) {

                    assetsObj.phoneNumbers.order = 2;

                }

                if (assetsObj.creditDebitCards) {

                    assetsObj.creditDebitCards.order = 3;

                }

                if (assetsObj.bankAccounts) {

                    assetsObj.bankAccounts.order = 4;

                }

                if (assetsObj.addresses) {

                    assetsObj.addresses.order = 5;

                }

                if (assetsObj.driversLicense) {

                    assetsObj.driversLicense.order = 6;

                }

                if (assetsObj.gamerTags) {

                    assetsObj.gamerTags.order = 7;

                }


                if (assetsObj.insuranceCards) {

                    assetsObj.insuranceCards.order = 8;

                }

                if (assetsObj.mothersMaidenName) {

                    assetsObj.mothersMaidenName.order = 9;

                }

                $scope.assets = assetsObj;

                const orders = [1, 2, 3, 4, 5, 6, 7, 8, 9];

                const sortedAssets = {};

                orders.forEach((index) => {

                    Object.entries(assetsObj).forEach((entry) => {

                        if (index === entry[1].order) {

                            sortedAssets[entry[0]] = entry[1];

                        }

                    });

                });

                $scope.assets = sortedAssets;

                $scope.assetsLoading = false;

            }

        };

        const dwmRepositoryObservable = dwmRepository.getObservable();
        dwmRepositoryObservable
            .subscribe(
                data => onDwmDataNext(data),
                () => { },
                () => { },
            );

        $scope.openAssetModal = (modal) => {

            Mixpanel.send('ConnectWeb AIA Entity Click', {
                Name: modal,
            });

            $state.go('root.dashboard.dwm.ltb', {
                ltb: modal,
                resourceId: 'asset',
            });

        };

        $scope.$on('$destroy', () => {

            dwmStatusListener();

        });

    }

}


class CryptoFaqDirective {

    constructor() {

        this.template = require('./dwm-assets.html');
        this.restrict = 'EA';
        this.replace = true;

        _controllerDependencies.push(($scope, $state, $rootScope) =>
            new DwmAssetsController($scope, $state, $rootScope));
        this.controller = _controllerDependencies;
        this.controllerAs = 'DwmAssetsCtrl';

    }

}

_directiveDependencies.push(() => new CryptoFaqDirective());


angular.module('directives')
    .directive('dwmAssets', _directiveDependencies);



// WEBPACK FOOTER //
// ./scripts/directives/dashboard/dwm-assets/dwm-assets.js